import Mock from 'mockjs'

const mockFiles = require.context('./modules', false, /\.js$/)
let mocks = []

mockFiles.keys().forEach(key => {
  mocks.push(...mockFiles(key))
})

mocks.forEach(item => {
  Mock.mock(process.env.VUE_APP_API_URL + item.url, item.type, item.response)
})
